import LockKeyholeSvg from '@assets/images/svg/lock-keyhole.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface LockKeyholeIconProps {
    size?: number;
    color?: string;
}

export const LockKeyholeIcon: React.FC<LockKeyholeIconProps> = ({
    size = 24,
    color = '#333333',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <LockKeyholeSvg
                width={size}
                height={size}
                color={color}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default LockKeyholeIcon;

